export function evalExpression(expression: string, data?: object): boolean {
  try {
    // eslint-disable-next-line no-new-func
    const fn = new Function('data', `with(data) {return !!(${expression});}`)
    // eslint-disable-next-line no-param-reassign
    data = data || {}
    return fn.call(data, data)
  } catch (e) {
    return false
  }
}

export function evalJS(js: string, data: object): any {
  try {
    // eslint-disable-next-line no-new-func
    const fn = new Function(
      'data',
      `with(data) {return ${js};}`,
    )
    // eslint-disable-next-line no-param-reassign
    data = data || {}
    return fn.call(data, data)
  } catch (e) {
    return null
  }
}
